// src/StudentLogin.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import Login from "./Login";

export default function StudentLogin() {
  const navigate = useNavigate();

  const onLogin = async (user) => {
    // driver?
    const driverSnap = await getDoc(doc(db, "drivers", user.uid));
    if (driverSnap.exists()) {
      navigate("/driver");
      return;
    }

    // admin?
    const adminSnap = await getDoc(doc(db, "admins", user.uid));
    if (adminSnap.exists()) {
      navigate("/admin");
      return;
    }

    // student
    navigate("/"); // if HomePage is "/"
  };

  return (
    <Login
      role="student"
      title="Student Login"
      subtitle="Sign in with your email and password."
      onLogin={onLogin}
    />
  );
}